import React from 'react';
import styles from './ContentsLayout.module.scss';

type Props = {
  children: React.ReactNode;
};

const ContentsLayout = React.forwardRef<HTMLDivElement, Props>((props, ref): JSX.Element => {
  const {
    children,
  } = props;

  return (
    <main className={styles.wrapper}>
      {children}
    </main>
  );
});

export default React.memo(ContentsLayout);
